import ReactDOM from 'react-dom';
import App from './App';
import { store } from './store/store';
import { Provider } from 'react-redux';
import './styles/index.scss';

export const myAccountWidget = {
    new: config => {
        return {
            render: () => {
                ReactDOM.render(
                    <>
                        <Provider store={store}>
                            <App data={config} />{' '}
                        </Provider>{' '}
                    </>,
                    document.querySelector(config.selector)
                );
            },
        };
    },
};

if (process.env.NODE_ENV === 'development') {
    window.tealium_data2track = [];

    //configurator object
    var config = {
        /* id of the dom element inside which the react component is rendered */
        selector: '#root',
        /* base path which will redirects to the pages*/
        basePath: '/to-us/my-account',
        /* name of the country */
        countryName: 'US',
        /* code of the currency */
        currencyCode: 'USD',
        /* the list of the geographics states*/
        stateList: [
            {
                code: 'AL',
                label: 'AL - Alabama',
                disabled: false,
            },
            {
                code: 'AK',
                label: 'AK - Alaska',
                disabled: false,
            },
            {
                code: 'AZ',
                label: 'AZ - Arizona',
                disabled: false,
            },
            {
                code: 'AR',
                label: 'AR - Arkansas',
                disabled: false,
            },
            {
                code: 'CA',
                label: 'CA - California',
                disabled: false,
            },
            {
                code: 'CO',
                label: 'CO - Colorado',
                disabled: false,
            },
            {
                code: 'CT',
                label: 'CT - Connecticut',
                disabled: false,
            },
            {
                code: 'DE',
                label: 'DE - Delaware',
                disabled: false,
            },
            {
                code: 'DC',
                label: 'DC - District of Columbia',
                disabled: false,
            },
            {
                code: 'FL',
                label: 'FL - Florida',
                disabled: false,
            },
            {
                code: 'GA',
                label: 'GA - Georgia',
                disabled: false,
            },
            {
                code: 'HI',
                label: 'HI - Hawaii',
                disabled: false,
            },
            {
                code: 'ID',
                label: 'ID - Idaho',
                disabled: false,
            },
            {
                code: 'IL',
                label: 'IL - Illinois',
                disabled: false,
            },
            {
                code: 'IN',
                label: 'IN - Indiana',
                disabled: false,
            },
            {
                code: 'IA',
                label: 'IA - Iowa',
                disabled: false,
            },
            {
                code: 'KS',
                label: 'KS - Kansas',
                disabled: false,
            },
            {
                code: 'KY',
                label: 'KY - Kentucky',
                disabled: false,
            },
            {
                code: 'LA',
                label: 'LA - Lousiana',
                disabled: false,
            },
            {
                code: 'ME',
                label: 'ME - Maine',
                disabled: false,
            },
            {
                code: 'MD',
                label: 'MD - Maryland',
                disabled: false,
            },
            {
                code: 'MA',
                label: 'MA - Massachusetts',
                disabled: false,
            },
            {
                code: 'MI',
                label: 'MI - Michigan',
                disabled: false,
            },
            {
                code: 'MN',
                label: 'MN - Minnesota',
                disabled: false,
            },
            {
                code: 'MS',
                label: 'MS - Mississippi',
                disabled: false,
            },
            {
                code: 'MO',
                label: 'MO - Missouri',
                disabled: false,
            },
            {
                code: 'MT',
                label: 'MT - Montana',
                disabled: false,
            },
            {
                code: 'NE',
                label: 'NE - Nebraska',
                disabled: false,
            },
            {
                code: 'NV',
                label: 'NV - Nevada',
                disabled: false,
            },
            {
                code: 'NH',
                label: 'NH - New Hampshire',
                disabled: false,
            },
            {
                code: 'NJ',
                label: 'NJ - New Jersey',
                disabled: false,
            },
            {
                code: 'NM',
                label: 'NM - New Mexico',
                disabled: false,
            },
            {
                code: 'NY',
                label: 'NY - New York',
                disabled: false,
            },
            {
                code: 'NC',
                label: 'NC - North Carolina',
                disabled: false,
            },
            {
                code: 'ND',
                label: 'ND - North Dakota',
                disabled: false,
            },
            {
                code: 'OH',
                label: 'OH - Ohio',
                disabled: false,
            },
            {
                code: 'OK',
                label: 'OK - Oklahoma',
                disabled: false,
            },
            {
                code: 'OR',
                label: 'OR - Oregon',
                disabled: false,
            },
            {
                code: 'PA',
                label: 'PA - Pennsylvania',
                disabled: false,
            },
            {
                code: 'RI',
                label: 'RI - Rhode Island',
                disabled: false,
            },
            {
                code: 'SC',
                label: 'SC - South Carolina',
                disabled: false,
            },
            {
                code: 'SD',
                label: 'SD - South Dakota',
                disabled: false,
            },
            {
                code: 'TN',
                label: 'TN - Tennessee',
                disabled: false,
            },
            {
                code: 'TX',
                label: 'TX - Texas',
                disabled: false,
            },
            {
                code: 'UT',
                label: 'UT - Utah',
                disabled: false,
            },
            {
                code: 'VT',
                label: 'VT - Vermont',
                disabled: false,
            },
            {
                code: 'VA',
                label: 'VA - Virginia',
                disabled: false,
            },
            {
                code: 'WA',
                label: 'WA - Washington',
                disabled: false,
            },
            {
                code: 'WV',
                label: 'WV - West Virginia',
                disabled: false,
            },
            {
                code: 'WI',
                label: 'WI - Wisconsin',
                disabled: false,
            },
            {
                code: 'WY',
                label: 'WY - Wyoming',
                disabled: false,
            },
        ],
        /* enable address autocomplete */
        autocomplete: 'on',
        /* key of Google Maps Api*/
        googleMapsKey: 'AIzaSyDIKnvcRs67JS68VapIMloObx8Va-J3src',
        /* client key of Google recaptcha */
        clientKeyRecaptcha: '6Lfd-MMZAAAAAFBfivuhuUJ1Q4RyHKGbuRMrcKD0',
        /* id of the store  */
        storeId: '12001',
        /* id of the catalog */
        catalogId: '12751',
        /* id language */
        langId: -1,
        /* id of the user logged */
        userId: '12345',
        /* email of the logged user*/
        userEmail: 'john.doe@email.com',
        /* session duration*/
        sessionDuration: 1800000,
        /* If true calls mocked data otherwise service  */
        mockRequest: true,
        /* property to check if it's the first time that user visits eye exams page */
        isFirstTimeOpenEyeExamHistoryPage: true,
        /* subscriptionKey to be sent to the API Manager*/
        subscriptionKey: '738a38bc3012477c8541e129b9d2b7be',
        /* category id of cl */
        categoryIdCl: '82862',
        /* phone number customer service */
        customerServicePhoneNumber: '1-877-848-8476',
        /* routing of the application. */
        pagesUrl: {
            /* url of the 'Dashboard' page */
            dashboard: '/dashboard',
            /* url of the "LOGOUT" Cta */
            logout: '/Logoff?myAcctMain=1&catalogId={catalogId}&langId={langId}&URL=LogonForm&storeId={storeId}',
            myAppointments: {
                /* url of 'Eye Exam' page */
                eyeExams: '/my-exams',
                /* url of 'In-store services' page */
                inStoreServices: '/in-store-services',
                /* url of 'My Prescription' page */
                myPrescriptions: '/my-prescriptions',
                /* url of 'FullPrescriptionForm' page - Add a new prescription */
                addPrescriptionForm: '/my-prescriptions/add-prescription',
                /* url of 'FullPrescriptionForm' page - Edit prescription */
                editPrescriptionForm: '/my-prescriptions/edit-prescription/:id',
                /* url of 'Prescription Contact Lenses' page - Add a new prescription */
                addPrescriptionContact: '/my-prescriptions/add-prescription-contact',
                /* url of 'Prescription Contact Lenses' page - Edit prescription */
                editPrescriptionContact: '/my-prescriptions/edit-prescription-contact/:id',
                /* url of 'Add Prescription Default Page' */
                addPrescriptionDefault: '/my-prescriptions/add-prescription-default',
            },
            myPurchases: {
                /* url of 'Online orders' page */
                onlineOrders: '/online-orders',
                /* url of 'In-store purchases' page */
                inStorePurchases: '/in-store-purchases',
                /* url of 'Order detail' page */
                orderDetail: '/order/:id',
                /* url of 'My addresses' page*/
                addresses: '/addresses',
                /* url of 'Payment methods' page*/
                paymentMethods: '/payment-methods',
            },
            myProfile: {
                /* url of 'Personal details' page */
                personalDetails: '/personal-details',
                /* url of 'Settings' page */
                settings: '/settings',
                /* url of 'My stores' page */
                myStores: '/my-stores',
                /* url of 'My Saved items' page */
                mySavedItems: '/my-saved-items',
                /* url of 'Inbox' page */
                inbox: '/inbox/',
            },
        },
        /* calls from component to external services/pages */
        callFromComponentToTO: {
            /* link to My Saved Items page. Used when clicked on 'My saved items' in menu */
            menu: {
                mySavedItems: '/to-us/eyeglasses',
            },
            dashboard: {
                /* link to store locator. Used when clicked on 'Search' CTA in 'My Store' tile */
                myStore:
                    '/to-us/eye-exam?locationEntry={LOCATION_ENTRY}&storeId={STORE_ID}&catalogId={CATALOG_ID}&langId={LANG_ID}&fromPage=StoreLocator&latLong=&fromHeader=true',

                /* link to find your look. Used when clicked on 'Start now' in 'Find your look' cta  */
                findYourLook: '/findyourlook',
                /* link to search page. Used when clicked on 'Shop now' CTA in 'My saved items' tile*/
                mySavedItems:
                    '/SearchDisplay?pageView=image&resultCatEntryType=2&searchTerm=*&sType=SimpleSearch&catalogId={CATALOG_ID}&langId={LANG_ID}&showResultsPage=true&storeId={STORE_ID}',
                /* link to all eyewear plp. Used when clicked on 'Shop now' CTA in My orders' tile'*/
                myOrders: '/to-us/eyeglasses',
                /* link to 'find in store' page. Used when clicked on 'Book An Appointment' CTA in 'My instore appointment' tile */
                bookAnAppointment: '/to-us/find-a-store',
                /* link to 'contact us' page. Used when clicked on 'Contact us' in 'Sync your purchases' panel */
                contactUs: '',
            },
            myAppointments: {
                eyeExams: {
                    /* link to 'find a store' page. Used when clicked on 'Schedule eye exam' CTA */
                    scheduleEyeExam: '/to-us/eye-exams',
                    /* link to exam page. Used when clicked on 'Reschedule' CTA */
                    rescheduleEyeExam:
                        '/ScheduleExamView?storeNumber={storeNumber}&reschedule=Y&clearExams=1&catalogId={catalogId}&modify=date&langId={langId}&apptId={appointmentId}&storeId={storeId}',
                    /* link to exam page. Used when clicked on 'Edit' CTA */
                    editEyeExam:
                        '/ScheduleExamView?storeNumber={storeNumber}&reschedule=Y&clearExams=1&catalogId={catalogId}&modify=patient&langId={langId}&apptId={appointmentId}&storeId={storeId}',
                    /* Digital intake form access link. Used when clicked on 'Eye Exam Forms online' CTA */
                    eyeExamFormsOnline: 'to-us/digital-intake-form?appId={encApptId}',
                    /* Digital intake form status endpoint */
                    myAccDifEndPoint: '???/{encApptId}',
                    /* Digital intake form status API key */
                    myAccDifKey: '???',
                },
                inStoreServices: {
                    /* link to 'find in store' page. Used when clicked on 'Schedule a store service' CTA */
                    scheduleAStoreService: '/to-us/find-a-store',
                    /* link to reschedule an appointment . Used when clicked on 'Reschedule' CTA */
                    rescheduleAppointment:
                        '/BookingDisplayView?storeId={storeId}&appointmentId={appointmentId}&storeNumber={storeNumber}&updateAppointment=true',
                    /* link to cancel an appointment . Used when clicked on 'Cancel Appointment' CTA */
                    cancelAppointment:
                        '/BookingDisplayView?storeId={storeId}&appointmentId={appointmentId}&storeNumber={storeNumber}&cancelAppointment=true',
                    /* link to retrieve the appointments list */
                    getAppointmentsList: '/tl-booking/api/v1/LC/account/appointments',
                },
            },
            myPurchases: {
                onlineOrders: {
                    /* link to TBD. Used when clicked on 'Find a store' CTA */
                    findAStore: '/to-us/find-a-store',
                    /* link to send rx post checkout page. Used when clicked on 'Send it now' CTA */
                    sendItNow:
                        '/DoctorInformationView?catalogId={catalogId}&langId={langId}&storeId={storeId}&orderId={orderId}&email={email}',
                    /* link to TBD. Used when clicked on 'Shop eyewear' CTA, visible when client has no orders */
                    shopEyewear: '/to-us/eyeglasses ',
                    /* link to TBD. Used when clicked on 'Shop contact lenses' CTA, visible when client has no orders */
                    shopContactLenses: '/to-us/contact-lenses',
					/* link to contact us page. Used when clicked on 'Contact us' label */
                    contactUs: '/to-us/contact-us',
					/* link to return policy page. Used when clicked on 'return policy' label */
                    returnPolicy: '/to-us/returns',
                },
                orderDetail: {
                    /* link to send rx post checkout page. Used when clicked on 'Submit now' CTA */
                    submitNow:
                        '/DoctorInformationView?catalogId={catalogId}&langId={langId}&storeId={storeId}&orderId={orderId}&email={email}',
                    /* link to exam page. Used when clicked on 'Schedule an eye exam' link */
                    scheduleEyeExam: '/to-us/find-a-store',
                    /* link to TBD. Used when clicked on 'Find a store' CTA */
                    findAStore: '/to-us/find-a-store',
                },
                inStorePurchases: {
                    /* link to stores list page. Used when clicked on 'Contact your store' link */
                    contactUs: '/to-us/eye-exams',
					/* link to return policy page. Used when clicked on 'return policy' label */
                    returnPolicy: '/to-us/returns',
                },
            },
            myProfile: {
                settings: {
                    /* link to send to the terms and conditions agreements*/
                    terms: '/to-us/terms-and-conditions',
                    /* link to send to the privacy policy agreement*/
                    privacy: '/to-us/privacy-policy',
                },
                myStores: {
                    /* link to 'find a store' page. Used when clicked on 'Schedule eye exam' CTA */
                    scheduleEyeExam:
                        '/ScheduleExamView?storeNumber={physicalStoreId}&clearExams=1&catalogId={catalogId}&langId={langId}&storeId={storeId}',
                    /* link to BTE scheduler page. Used when clicked on 'Other services' CTA */
                    otherServices: '/BookingDisplayView?storeNumber={storeNumber}',
                    /* link to store locator. Used when clicked on 'Search' CTA in 'My Store' tile */
                    findAStore:
                        '/to-us/eye-exam?locationEntry={LOCATION_ENTRY}&storeId={STORE_ID}&catalogId={CATALOG_ID}&langId={LANG_ID}&fromPage=StoreLocator&latLong=&fromHeader=true',
                },
            },
        },
    }; //init and render widget

    var myAccount = myAccountWidget.new(config);
    myAccount.render();
}
